'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _indexOfInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/index-of');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');
require('../expression/index.js');
var atom_model = require('../expression/atom.model.js');
var condition_model = require('../expression/condition.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _indexOfInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_indexOfInstanceProperty);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);

var DataFilterLogic = /*#__PURE__*/function () {
  function DataFilterLogic() {
    _classCallCheck__default["default"](this, DataFilterLogic);
  }
  return _createClass__default["default"](DataFilterLogic, null, [{
    key: "convertJSONExprModelForGSQL",
    value:
    /**
     * Convert ExprModel's LoadingVariable operand value for for GSQL.
     *
     * @param {BaseCondition} exprJson
     * @param {DataFieldSchema[]} currentDataSchema
     * @memberof DataFilterLogic
     */
    function convertJSONExprModelForGSQL(exprModel, currentDataSchema) {
      var _context,
        _this = this;
      if (!exprModel.operands || exprModel.operands.length === 0) {
        return;
      }
      _forEachInstanceProperty__default["default"](_context = exprModel.operands).call(_context, function (operand) {
        if (operand instanceof atom_model.LoadingVariable && typeof operand.value === 'number') {
          var _context2;
          var index = operand.value;
          var value = _mapInstanceProperty__default["default"](_context2 = currentDataSchema[index].path).call(_context2, function (item) {
            return "\"".concat(item, "\"");
          }).join(':');
          operand.value = value;
        }
        if (operand instanceof condition_model.BaseCondition) {
          _this.convertJSONExprModelForGSQL(operand, currentDataSchema);
        }
      });
    }

    /**
     * Convert ExprModel's LoadingVariable operand value for ExpressionForm.
     *
     * @param {BaseCondition} exprJson
     * @param {DataFieldSchema[]} currentDataSchema
     * @memberof DataFilterLogic
     */
  }, {
    key: "convertJSONExprModelForVisualExprForm",
    value: function convertJSONExprModelForVisualExprForm(exprModel, currentDataSchema) {
      var _context3,
        _this2 = this;
      if (!exprModel || !exprModel.operands || exprModel.operands.length === 0) {
        return;
      }
      _forEachInstanceProperty__default["default"](_context3 = exprModel.operands).call(_context3, function (operand) {
        if (operand instanceof atom_model.LoadingVariable && typeof operand.value === 'string') {
          var _context4, _context5;
          var value = _mapInstanceProperty__default["default"](_context4 = operand.value.split(':')).call(_context4, function (item) {
            return item.replace('"', '').replace('"', '');
          });
          var index = _indexOfInstanceProperty__default["default"](_context5 = _mapInstanceProperty__default["default"](currentDataSchema).call(currentDataSchema, function (dataFieldSchema) {
            return _JSON$stringify__default["default"](dataFieldSchema.path);
          })).call(_context5, _JSON$stringify__default["default"](value));
          operand.value = index;
        }
        if (operand instanceof condition_model.BaseCondition) {
          _this2.convertJSONExprModelForVisualExprForm(operand, currentDataSchema);
        }
      });
    }
  }]);
}();

exports.DataFilterLogic = DataFilterLogic;
